// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__2Cua-","consentsList":"PatientConsents_consentsList__2Dg0x","consentsListEmpty":"PatientConsents_consentsListEmpty__2wj5R"};